<template>
  <div style="display: block" class="uk-modal uk-open uk-animation-fade uk-animation-fast" @blur="closeModal">
    <div class="uk-modal-dialog tm-func-modal" v-click-outside="closeModal">
      <div class="uk-modal-header">
        <div class="tm-background-green uk-padding-xsmall uk-position-top-right uk-text-bold tm-light"
             style="cursor: pointer;"
             @click="closeModal()">
          <md-icon>close</md-icon>
        </div>
        <div class="uk-modal-title">
          <div data-uk-grid class="uk-grid uk-flex-middle uk-grid-small">
            <div>
              Анкета
            </div>
          </div>
        </div>
      </div>
      <div class="uk-modal-body">
        <div v-for="(item, index) in worksheets" :key="index" class="uk-grid uk-grid-small uk-flex-middle uk-margin"
             data-uk-grid>
          <div>
        <span class="uk-label tm-label">
          {{ index + 1 }}
        </span>
          </div>
          <div class="uk-width-expand">
            {{ item.title }}
          </div>
          <div v-if="item.type === 'boolean'">
            <input class="uk-checkbox" type="checkbox" v-model="responses[index].answer">
          </div>
          <div v-else-if="item.type === 'textarea'" class="uk-width-1-1">
            <textarea class="uk-textarea" v-model="responses[index].answer"></textarea>
            <div v-if="errors[index]" class="uk-text-danger">{{ errors[index] }}</div>
          </div>
          <div v-else-if="item.type === 'input'" class="uk-width-1-1">
            <input class="uk-input" type="text" v-model="responses[index].answer">
            <div v-if="errors[index]" class="uk-text-danger">{{ errors[index] }}</div>
          </div>
        </div>
      </div>
      <div class="uk-modal-footer uk-text-right">
        <button @click.prevent="updateWorksheet()" type="button" class="uk-button uk-button-success">
          Сохранить
          <span v-if="loader" class="uk-icon uk-spinner uk-margin-left" data-uk-spinner></span>
        </button>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: "ModalUserWorksheetDialog",
  props: {
    user: {
      type: Object,
      require: true
    },
    local_page_keys: {
      type: Object,
      require: true
    }
  },
  data() {
    return {
      worksheets: [
        {
          title: 'Вопрос Да/Нет',
          type: 'boolean'
        },
        {
          title: 'Вопрос - свой ответ',
          type: 'textarea'
        },
        {
          title: 'Вопрос - свой ответ (короткий)',
          type: 'input'
        }
      ],
      responses: {},
      loader: false,
      errors: {}
    }
  },

  methods: {
    async updateWorksheet() {

      if (this.validateResponses())
        return;

      this.loader = true;
      try {
        let payload = {
          'data': JSON.stringify(this.responses)
        }
        await this.$store.dispatch("profile/updateWorksheet", payload);
        await this.$store.dispatch(
            "alerts/success",
            'Анкета сохранена'
        );
      } catch (e) {
        await this.$store.dispatch(
            "alerts/error",
            this.local_page_keys.alert_something_wrong
        );
      } finally {
        this.loader = false;
      }
    },
    initializeResponses(data) {

      if (!data) {
        this.responses = this.worksheets.map((item, index) => ({
          question: item.title,
          answer: item.type === 'boolean' ? false : ''
        }))
        return;
      }

      const savedData = JSON.parse(data);
      this.responses = this.worksheets.map((item) => {
        const savedAnswer = savedData.find((dataItem) => dataItem.question === item.title);
        return {
          question: item.title,
          answer: savedAnswer ? savedAnswer.answer : (item.type === 'boolean' ? false : '')
        };
      });

    },
    validateResponses() {
      let hasErrors = false;
      this.errors = {}; // Очистить ошибки перед новой проверкой

      for (let index = 0; index < this.worksheets.length; index++) {
        const questionType = this.worksheets[index].type;
        const answer = this.responses[index].answer;

        if (questionType !== 'boolean' && !answer) {
          this.errors[index] = 'Ответ не может быть пустым';
          hasErrors = true;
        }
      }

      return hasErrors;
    },
    closeModal() {
      this.$emit('close');
    },

  },
  async created() {
    this.initializeResponses(this.user.worksheet)
  }
}
</script>